import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckinSegmentFragment, IGdsServiceInfo, SegmentFragment } from '@websky/graphql';
import { useTheme } from '../../../../theme';
import ServiceCard, { ServiceCardBaseProps } from '../ServiceCard/ServiceCard';

const Seat: React.FC<ServiceCardBaseProps> = props => {
	const { t } = useTranslation('Checkout');
	const theme = useTheme('RefundSummary').CommonContent;

	const getServiceName = (service: IGdsServiceInfo, productId: string, passengerId: string) => {
		const traveller = props.passengers.find(passenger => passenger.id === passengerId);

		const seat = traveller.services?.seats?.find(seat => {
			return seat.product.id === productId;
		});

		let segment: CheckinSegmentFragment | SegmentFragment;

		if (Array.isArray(props.flight)) {
			segment = props.flight.find(segment => segment.id === seat.segment.id);
		} else {
			segment = props.flight.segments.find(segment => segment.segment.id === seat.segment.id).segment;
		}

		return (
			<>
				{segment.departure.airport.iata} - {segment.arrival.airport.iata}, {seat.seat.number}
			</>
		);
	};

	return (
		<ServiceCard
			type="seats"
			className={theme.serviceCard_seats}
			title={t('Seats')}
			description=""
			getServiceName={getServiceName}
			{...props}
		/>
	);
};

export default Seat;
